module.exports = __webpack_public_path__ + "assets/img/gpay_btn.9a59c56d.svg";